// =====================================================================
// TypologiesTab.jsx — Gestion typologies erreurs (admin)
// =====================================================================
import { useState, useEffect } from 'react';
import { errors as errorsApi } from '../../services/api.js';

const CATEGORIES = [
  { v: 'PREPARATION', label: 'Préparation' },
  { v: 'ENCODAGE', label: 'Encodage' },
  { v: 'PROCEDURE', label: 'Procédure' },
  { v: 'RECEPTION', label: 'Réception' },
  { v: 'TRI', label: 'Tri' },
  { v: 'INVENTAIRE', label: 'Inventaire' },
  { v: 'ADMIN', label: 'Administratif' },
  { v: 'SECURITE', label: 'Sécurité' },
  { v: 'REGLEMENT', label: 'Règlement' },
  { v: 'AUTRE', label: 'Autre' },
];

export default function TypologiesTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newLabel, setNewLabel] = useState('');
  const [newCategory, setNewCategory] = useState('PREPARATION');
  const [creating, setCreating] = useState(false);

  async function load() {
    setLoading(true);
    try {
      const all = await errorsApi.listTypologies(false);
      setItems(all);
    } catch (e) { alert('Erreur: ' + (e.response?.data?.message || e.message)); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  async function handleCreate() {
    if (!newLabel.trim()) return;
    setCreating(true);
    try {
      await errorsApi.createTypology({ category: newCategory, label: newLabel.trim() });
      setNewLabel('');
      load();
    } catch (e) { alert('Erreur: ' + (e.response?.data?.message || e.message)); }
    finally { setCreating(false); }
  }

  async function handleToggleActive(t) {
    try {
      await errorsApi.updateTypology(t.id, { isActive: !t.isActive });
      load();
    } catch (e) { alert('Erreur: ' + (e.response?.data?.message || e.message)); }
  }

  async function handleDelete(t) {
    if (!confirm(`Supprimer la typologie "${t.label}" ?\n(Si utilisée, elle sera seulement désactivée)`)) return;
    try {
      const r = await errorsApi.deleteTypology(t.id);
      if (r.deactivated) alert(`Typologie utilisée par ${r.usage} erreur(s) — désactivée plutôt que supprimée.`);
      load();
    } catch (e) { alert('Erreur: ' + (e.response?.data?.message || e.message)); }
  }

  // Group by category
  const grouped = items.reduce((acc, t) => {
    if (!acc[t.category]) acc[t.category] = [];
    acc[t.category].push(t);
    return acc;
  }, {});

  return (
    <div>
      <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, marginBottom: 16 }}>
        <h3 style={{ margin: '0 0 10px', fontSize: 14 }}>+ Nouvelle typologie</h3>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <select value={newCategory} onChange={e => setNewCategory(e.target.value)} style={inputStyle} disabled={creating}>
            {CATEGORIES.map(c => <option key={c.v} value={c.v}>{c.label}</option>)}
          </select>
          <input type="text" value={newLabel} onChange={e => setNewLabel(e.target.value)}
            placeholder="Ex: erreur de préparation : ..."
            style={{ ...inputStyle, flex: 1, minWidth: 280 }} disabled={creating}
            onKeyDown={e => e.key === 'Enter' && handleCreate()}
          />
          <button onClick={handleCreate} disabled={creating || !newLabel.trim()} style={primaryBtn}>
            {creating ? 'Création…' : '+ Ajouter'}
          </button>
        </div>
      </div>

      {loading && <div style={{ padding: 20, color: '#64748b' }}>Chargement…</div>}
      {!loading && Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b)).map(([cat, list]) => (
        <div key={cat} style={{ marginBottom: 18 }}>
          <h3 style={{ fontSize: 13, color: '#475569', margin: '0 0 8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            {CATEGORIES.find(c => c.v === cat)?.label || cat} <span style={{ color: '#94a3b8', fontWeight: 400 }}>({list.length})</span>
          </h3>
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8 }}>
            {list.map((t, idx) => (
              <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderTop: idx > 0 ? '1px solid #f1f5f9' : 'none', opacity: t.isActive ? 1 : 0.5 }}>
                <span style={{ flex: 1, fontSize: 13, color: t.isActive ? '#1e293b' : '#94a3b8' }}>
                  {t.label}
                </span>
                <button onClick={() => handleToggleActive(t)} style={{ ...secondaryBtn, fontSize: 11 }}>
                  {t.isActive ? '🟢 Active' : '⚪ Inactive'}
                </button>
                <button onClick={() => handleDelete(t)} style={{ ...secondaryBtn, color: '#b91c1c', borderColor: '#fecaca', background: '#fef2f2', fontSize: 11 }}>
                  🗑 Supprimer
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

const inputStyle = { padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, fontFamily: 'inherit' };
const primaryBtn = { padding: '7px 14px', background: '#4338ca', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 };
const secondaryBtn = { padding: '4px 10px', background: '#fff', border: '1px solid #d1d5db', borderRadius: 4, cursor: 'pointer', fontSize: 12 };
